export const isIframe = (): boolean => window.parent !== parent;
